"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ContextMenu_1 = __importDefault(require("./ContextMenu"));
var styled_components_1 = __importStar(require("styled-components"));
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: ", ";\n\theight: ", ";\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tpadding: 15px;\n\tbackground: ", ";\n\tborder-style: none;\n\tborder-width: 1px;\n\t\n\tuser-select: none;\n\t\n\toverflow: visible;\n\tposition: relative;\n\n\topacity: ", ";\n\n\t", "\n"], ["\n\twidth: ", ";\n\theight: ", ";\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tpadding: 15px;\n\tbackground: ", ";\n\tborder-style: none;\n\tborder-width: 1px;\n\t\n\tuser-select: none;\n\t\n\toverflow: visible;\n\tposition: relative;\n\n\topacity: ", ";\n\n\t", "\n"])), function (props) { return props.smaller ? "60px" : "100px"; }, function (props) { return props.smaller ? "60px" : "100px"; }, function (props) { return props.active ? "lightgrey" : "white"; }, function (props) { return props.disabled ? "0.5" : "1"; }, function (props) { return props.theme.iconButton; });
var Icon = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin: auto;\n\tobject-fit: contain; /*Use background-image: url(...); & background-size: contain; instead for IE support*/\n\twidth: 100%;\n\theight: 100%;\n\t\n\t", "\n\t", "\n"], ["\n\tmargin: auto;\n\tobject-fit: contain; /*Use background-image: url(...); & background-size: contain; instead for IE support*/\n\twidth: 100%;\n\theight: 100%;\n\t\n\t", "\n\t", "\n"])), function (props) { return props.showName && "width: 50%; height: 50%; padding-bottom:8px"; }, function (props) { return props.theme.iconButtonIcon; });
var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (e) {
            if (_this.props.children !== undefined) {
                _this.setState({ active: !_this.state.active });
                e.stopPropagation();
            }
            else {
                if (window.options_tagger !== undefined && _this.props.taggingOverride !== "notag") {
                    if (_this.props.taggingOverride) {
                        window.options_tagger(_this.props.taggingOverride);
                    }
                    else if (_this.props.automationId) {
                        window.options_tagger(_this.props.automationId);
                    }
                }
                if (_this.props.onClick) {
                    _this.props.onClick(e);
                }
            }
        };
        _this.onKeyPress = function (ev) {
            var ESC = 27;
            if (ev.keyCode === ESC) {
                _this.onClicked();
            }
        };
        _this.onClicked = function () {
            _this.setState({ active: false });
        };
        _this.state = {
            active: false
        };
        if (props.children !== undefined) {
            if (_this.props.onClick !== undefined) {
                console.error("IconButton: You can have an onClick, or children, but not both. onClick provided to " + props.name + " will not be called.");
            }
        }
        return _this;
    }
    IconButton.prototype.render = function () {
        return (react_1.default.createElement("div", { style: { display: "inline-block" } },
            " ",
            react_1.default.createElement(Button, { disabled: this.props.disabled ? true : false, onClick: this.onClick, active: this.state.active, "aria-label": this.props.name, smaller: this.props.small === true, className: this.props.className, id: this.props.id, "data-automationid": this.props.automationId },
                react_1.default.createElement(Icon, { showName: this.props.showName === true }, typeof this.props.icon === 'string' ?
                    react_1.default.createElement("img", { src: this.props.icon, alt: "" })
                    :
                        this.props.icon),
                this.props.showName &&
                    react_1.default.createElement("div", null, this.props.name)),
            this.state.active &&
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { onClick: this.onClicked, onKeyPress: this.onKeyPress, tabIndex: -1, "aria-label": "close dropdown", style: { position: "fixed", top: 0, right: 0, left: 0, bottom: 0, zIndex: 80, backgroundColor: "rgba(0,0,0,0.0)" }, role: "button" }),
                    react_1.default.createElement("div", { style: { position: "absolute", top: "105%", right: 0, zIndex: 100, minWidth: "200px" } },
                        react_1.default.createElement(ContextMenu_1.default, { onClick: this.onClicked }, this.props.children)))));
    };
    return IconButton;
}(react_1.Component));
exports.default = styled_components_1.withTheme(IconButton);
var templateObject_1, templateObject_2;
//# sourceMappingURL=IconButton.js.map